
import { Vue, Component, Prop, Watch } from "vue-property-decorator"
import FormField from "../../base_classes/FormField"
import modaldialog from "../dialogs/modaldialog"

@Component
export default class FreeTextField extends FormField {
    @Prop() label!: string
    @Prop() field!: string
    @Prop() errorRequired!: boolean
    @Prop() icon?: string
    @Prop() onClick?: Function
    @Prop() placeholder?: string

    mounted() {
        this.textInput = this.value[this.field] || ""
    }

    show = false
    textInput = ""

    get changed() {
        if (!this.textInput && !this.value[this.field]) return false
        return this.textInput != this.value[this.field]
    }

    input() {
        if (this.errorRequired) this.$emit("clearErrorRequired", this.field)
        this.$emit("input", this.value)
    }
    submitText() {
        this.show = false
        Vue.set(this.value, this.field, this.textInput || null)
    }
    clearText() {
        this.show = false
        this.textInput = ""
        Vue.set(this.value, this.field, null)
    }
    cancelEdit() {
        this.textInput = this.value[this.field]
        this.show = false
    }

    @Watch("show")
    @Watch("changed")
    watchModal() {
        modaldialog.set(this, this.show && this.changed, true)
    }
}
